import { SimpleTemplate, Template } from '../types/template';
import { Property, BareProperty } from '../types/property';
import { mapBy, notUndefined } from './functional';

export function extractTagsFromProperty(tags: string[], property: Property | BareProperty) {
  const tagsDict = mapBy(property.tags, '_id');

  return tags.map(tg => tagsDict[tg]).filter(notUndefined);
}

export function convertToSimpleTemplate(template: Template): SimpleTemplate {
  const { feeds: _, plan: __, ...rest } = template;
  return {
    ...rest,
    dayType: template.plan.day.type,
    eventsCount: template.plan.events.length,
    venueDataCount: template.plan.venueData.length,
    contentCount: template.plan.content.length,
  };
}
